import clsx from 'clsx'
import { CheckCircle } from 'lucide-react'

import { type SingleSelectedValueFilter } from 'components/brokers/types'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select'

const HasConfirmedEnrollmentsFilter = ({
  selectValue,
  selectedValue,
}: SingleSelectedValueFilter) => {
  const options = [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ]

  return (
    <div
      style={{ width: '300px' }}
      className={clsx({
        'rounded-md bg-slate-50 flex items-center justify-between px-2 py-1 text-sm':
          true,
        'text-thatch-purple': selectedValue,
        'text-ds-text-secondary': !selectedValue,
      })}
    >
      <div className='flex items-center gap-2'>
        <CheckCircle size={16} />
        <span>Confirmed Enrollments?</span>
      </div>
      <div className='ml-auto flex items-center justify-between shrink-0'>
        <Select value={selectedValue} onValueChange={selectValue}>
          <SelectTrigger className='h-8 w-[140px]'>
            <SelectValue placeholder='Select...' />
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}

export default HasConfirmedEnrollmentsFilter
